import { render, staticRenderFns } from "./Slitsliders.vue?vue&type=template&id=a8da552c&scoped=true&"
import script from "./Slitsliders.vue?vue&type=script&lang=js&"
export * from "./Slitsliders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8da552c",
  null
  
)

export default component.exports